import { useCases } from "@/content/use-cases";
import { Badge } from "@/components/ui/Badge";
import { Card } from "@/components/ui/Card";
import { GlobalCTA } from "@/components/ui/CTA";
import { List } from "@/components/ui/List";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";

export default function UseCasesPage() {
  return (
    <>
      <PageHero
        eyebrow="Use cases"
        title="Marketing moments Agentic Plus supports"
        description="Agentic Plus is most useful when creative decisions need evidence, production, review, and a record of what happened next. These are the common starting points."
      />

      <Section title="Core use cases" tone="surface">
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {useCases.map((useCase) => (
            <Card
              key={useCase.id}
              id={useCase.id}
              title={useCase.title}
              description={useCase.problem}
            >
              <div className="mt-4">
                <h4 className="text-sm font-bold uppercase tracking-wide text-mint-dark">
                  Approach
                </h4>
                <p className="mt-2 text-ink-soft">{useCase.approach}</p>
              </div>
              <div className="mt-5">
                <h4 className="text-sm font-bold uppercase tracking-wide text-mint-dark">
                  Outputs
                </h4>
                <List items={useCase.outcomes} variant="plain" className="mt-3" />
              </div>
              <div className="mt-5">
                <Badge tone={useCase.status === "Planned" ? "amber" : "mint"}>
                  {useCase.status}
                </Badge>
              </div>
            </Card>
          ))}
        </div>
      </Section>

      <Section
        title="How to choose a first mission"
        lead="Start where the team already knows the problem but lacks a repeatable path from evidence to approved assets."
      >
        <div className="grid gap-6 md:grid-cols-3">
          {[
            {
              title: "One product",
              description:
                "Choose a product with stable facts, known customers, and a measurable business goal.",
            },
            {
              title: "One decision",
              description:
                "Pick a launch angle, fatigue hypothesis, or localization variant rather than every asset at once.",
            },
            {
              title: "One review path",
              description:
                "Name who reviews brand, spend, and delivery so approvals do not become a bottleneck.",
            },
          ].map((item) => (
            <article key={item.title} className="surface-card p-6">
              <h3 className="text-xl font-bold">{item.title}</h3>
              <p className="mt-3 text-ink-soft">{item.description}</p>
            </article>
          ))}
        </div>
      </Section>

      <GlobalCTA />
    </>
  );
}
